import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {lang} from 'js/Core/lang';
import CalendarContainer from 'js/Containers/Calendar.container';
const txtLang = lang.txt;


const mapStateToProps = state => {
	return {
		errors: state.errors
	}
}
const mapDispatchToProps = dispatch => {
		return {

		}
}

class BookerTime extends Component {
    constructor(props) {
        super(props);
      }


    render() {
		const {errors} = this.props;
        return (
          	<div className="timeline-main">
				<div className="timeline-text-note label-header">{lang.txt.header_note_timeline}</div>
				<h3  className="cor_ttl">{txtLang.label_header_timeline_yuri}</h3>
				<table id='scheduleDate' className="form">
					<tbody>
					<tr>
						<th rowSpan='2'>{txtLang.label_select_timeline} <span className="red">{txtLang.label_required}</span></th>
						<td className='nonbd'>
							{
								errors.scheduleDate && errors.scheduleDate.invalid ? <p><span className="message-error">{errors.scheduleDate.message}</span></p> : ''
							}
							<CalendarContainer   />
						</td>
					</tr>
					</tbody>
				</table>						
        	</div>
        )
      }
    }


    export default connect(mapStateToProps, mapDispatchToProps)(BookerTime);
